import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import { useMemo } from "react";

import { List } from "@/components/list/List";

import { DataTableSettingsContextProvider } from "@/components/data-table/DataTableSettingsContext";
import { DataTableSettings } from "@/types/dataTableSettings";
import { DisplayProjectManager } from "@/types/projectManager";
import { ProjectManagersAddUsersButton } from "@/modules/projects/components/managers/ProjectManagersAddUsersButton";
import { ProjectManagersRemoveUsersButton } from "@/modules/projects/components/managers/ProjectManagersRemoveUsersButton";

export const ProjectManagersDirectoryContent = () => {
  const settings = useDataTableSettings<DisplayProjectManager>();
  const tableSettings = useMemo<DataTableSettings<DisplayProjectManager>>(
    () => ({ ...settings }),
    [settings],
  );

  return (
    <DataTableSettingsContextProvider value={tableSettings}>
      <List.Content>
        <List.Status>
          <ProjectManagersRemoveUsersButton variant="secondary" />
          <ProjectManagersAddUsersButton variant="secondary" />
        </List.Status>
      </List.Content>
    </DataTableSettingsContextProvider>
  );
};
